// removed by extract-text-webpack-plugin
module.exports = {"component":"_1oj4yI_27HAFUf9BHSIVnb","initials":"_1Oa7Fny1q7TGaiCcLw0Tg3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UserBadge/UserBadge.css
// module id = 993
// module chunks = 0